(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-featured-products"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let swiperInstance;
    const breakpoint = 769;
    const swiperContainer = document.querySelector('.js-featured-products-swiper');

    function initSwiper() {
      swiperInstance = new Swiper('.js-featured-products-swiper', {
        slidesPerView: 2.5,
        spaceBetween: 16,
        loop: true,
        allowTouchMove: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        breakpoints: {
          300: {
            slidesPerView: 1.5,
          },
          500: {
            slidesPerView: 2.5,
          }
        },
      });
    }

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function handleResize() {
      if (window.innerWidth < breakpoint) {
        if (!swiperInstance) {
          initSwiper();
        }
      } else {
        destroySwiper();
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let swiperInstance;
    const breakpoint = 769;
    const swiperContainer = document.querySelector('.js-testimonials-swiper');

    function initSwiper() {
      swiperInstance = new Swiper('.js-testimonials-swiper', {
        slidesPerView: 1.5,
        spaceBetween: 16,
        loop: true,
        allowTouchMove: true,
        speed: 1000,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      });
    }

    function destroySwiper() {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }

    function handleResize() {
      if (window.innerWidth < breakpoint) {
        if (!swiperInstance) {
          initSwiper();
        }
      } else {
        destroySwiper();
      }
    }

    window.addEventListener('resize', handleResize);
    handleResize();
  });

  } catch(e) { console.error(e); }
})();
})();
